import { observable } from "mobx";
import { observer } from "mobx-react";
import * as React from "react";
import { AppStore } from "../../stores/AppStore";
import { MDBBtn, MDBCol, MDBRow } from "mdbreact";
import BootstrapTable from "react-bootstrap-table-next";
import { BootstrapTable as BootstrapTableOld, TableHeaderColumn } from "react-bootstrap-table";
import { Alert, Alignment, Button, FormGroup, HTMLSelect, InputGroup, Tab, Tabs, Classes, Dialog, NumericInput, Collapse, Switch } from "@blueprintjs/core";
import { format_erro, format_finalizado, formatCnpj } from "../../utils";
import moment from "moment";
import { DateRangePicker30 } from "../utils/DateRangePicker30";
import { toast } from "react-toastify";
import { Pager } from "../utils/Pager";
import ReactJson from "react-json-view";
import { BotsAdminStore } from "../../stores/admin/BotsAdminStore";
import { getOptions, getTag, optionsTipo } from "../utils/getStatus";
import { IconButton } from "@mui/material";
import LoadingModal from "../loading/LoadingModal";
import { DefaultSelect, filterItens, renderItens } from "../utils/DefaultSelect";
import { JsonEditor } from "json-edit-react";
import { AppIcon } from "../utils/AppIcon";
import { SefaErrosPage } from "./SefaErrosPage";

interface state {

  date1: string,
  date2: string

}

const categoriasParcelas = {
  0: "Todas",
  1: "PGFN",
  2: "RECEITA FEDERAL",
  3: "ESPECIAIS",
  4: "SIMPLES NACIONAL",
  5: "SEFA"
};

const listaEstados = {
  "": "Todos",
  "rs": "RS",
  "ap": "AP",
  "go": "GO",
  "pa": "PA",
  "mg": "MG",
  "sp": "SP"
};

const modeloNota = {
  "": "Todas",
  "nfe": "NF-E",
  "nfce": "NFC-e",
  "nfse": "NFS-e",
  "cte": "CT-e"
};

const getPeriodoMesAtual = () => {
  const inicio = moment().startOf("month");
  const fim = moment().endOf("month");

  return {
    periodo: [inicio.toDate(), fim.toDate()],
    date1: inicio.format("YYYY-MM-DD"),
    date2: fim.format("YYYY-MM-DD")
  };
};

@observer
export class BotsAdminPage extends React.Component<{}, state> {

  obs = observable({
    selectedPeriod: [] as any,
    open_create: false as boolean,
    selectedRows: [] as any,
    allSelected: false as boolean,
    tipo: {} as { cod: string, descricao: string },
    status: "" as string,
    finalizado: "todos" as string,
    loading: false as boolean,
    erro: "todos" as string,
    cnpj: "" as string,
    id: "" as string,
    task_id: "" as string,
    conta_id: "" as string,
    open_erros_bots: false as boolean,
    erros_solicitacoes: [] as any,
    open_detalhes: false as boolean,
    tarefa: {} as any,
    loading_download: false as boolean,
    loading_solicitacoes: false as boolean,
    open_editar: false as boolean,
    tarefa_original: null as any,
    tarefa_editada: {} as any,
    loading_editar: false as boolean,
    tabAtiva: "tarefas",
    current_page: 1 as number,
    selectedPeriodoRelatorio: [] as any,
    relatorio_cnpj: "" as string,
    relatorio_tipo: {} as { cod: string, descricao: string },
    relatorio_date1: "" as string,
    relatorio_date2: "" as string,
    erros_relatorio: [] as any,
    open_erros_relatorio: false as boolean,
    loading_relatorios: false as boolean,
    loading_exportar: false as boolean,
    partition: "" as string,
    open_partition: false as boolean,
    categoria_parcela: 0 as number,
    lista_estados: "" as string,
    modelo_nota: "" as string,
    open_filters: false as boolean,
    forcar_reinicializacao: false as boolean
  })

  constructor(props) {
    super(props)
    this.state = { date1: "", date2: "" };
    const periodoRelatorio = getPeriodoMesAtual();
    this.obs.selectedPeriodoRelatorio = periodoRelatorio.periodo;
    this.obs.relatorio_date1 = periodoRelatorio.date1;
    this.obs.relatorio_date2 = periodoRelatorio.date2;
  }

  async componentDidMount() {
    AppStore.setTitle("Gerenciamento de Tarefas");

    BotsAdminStore.obs.tabelaBots = []
    BotsAdminStore.obs.currentPageBot = 1
    BotsAdminStore.obs.length_bots = 0
  }

  /**
  * Lista de campos restritos que não devem ser editados pelo usuário.
  *
  * Esses campos normalmente representam identificadores, datas de controle,
  * tokens, vínculos internos, períodos de referência ou informações sensíveis
  * utilizadas pelo sistema.
  *
  * A lista é usada para impedir que determinados atributos sejam alterados
  * durante a edição manual do JSON, preservando a integridade dos dados e
  * evitando alterações em campos críticos da aplicação.
  *
  * @readonly
  * @type {string[]}
  */

  readonly restrictData = [
    "_id", "_insertedTS", "_modifiedTS", "conta_id", "solicitacao_id", "task_id", "manifestacao_id", "id", "cnpj", "inserted_at", "cnds_id", "data_agendamento",
    "integration_id", "sped_id", "pgdas_id", "contestacao_calc_id", "contestacao_id", "calc_id", "caixapostal_id", "importacao_id", "danfe_id", "fgtsdigital_id",
    "send_at", "paraupebas_id", "agendamento_id", "relatorio_id", "sitfis_id", "jwt", "bearer", "response_id", "autenticar_procurador_token", "regime_id",
    "auto_pgdas_id", "das_id", "auto_das_id", "senha_certificado", "updated_at", "periodo_inicial", "periodo_final", "contestacao_produto_id", "notas_id",
    "contestacao_data", "cnpj_destino", "empresa_id", "periodoNotas", "periodoAno", "data_inicio", "data_fim", "ids_calc_apuracao", "classificacao_ids_apuracao",
    "template", "date_start", "date_end", "cnpj_origem", "dhemi", "dhaut", "empresa", "numero_dae", "data_vencimento", "data_referencia", "data_calculo",
    "cnpj_contabilidade", "ids", "user_id", "idServico"
  ];

  /**
  * Verifica se o primeiro nível de um caminho corresponde a um campo sensível/restrito.
  * O método compara o primeiro item do `path` com a lista `restrictData`.
  * Caso o campo esteja nessa lista, ele deve ser tratado como protegido, 
  * impedindo ou limitando sua edição manual no JSON. 
  * @param {any[]} path - Caminho do campo dentro do objeto JSON. 
  * @returns {boolean} Retorna `true` se o campo for sensível/restrito. 
  */

  isCampoSensivel = (path: any[] = []) => {
    return this.restrictData.includes(String(path?.[0]));
  };

  /** 
  * Verifica se um valor é um objeto simples. 
  * Retorna `true` apenas quando o valor é diferente de `null`, 
  * possui tipo `"object"` e não é um array. 
  * @param {any} value - Valor que será validado. 
  * @returns {boolean} Retorna `true` se o valor for um objeto simples. 
  */

  isObject = (value: any) => {
    return value !== null && typeof value === "object" && !Array.isArray(value);
  };

  /**
  * Compara dois valores JSON para verificar se são equivalentes.
  * A comparação é feita convertendo os valores para string JSON.
  * Essa abordagem funciona bem para estruturas simples, como objetos, 
  * arrays, strings, números, booleanos e valores nulos. 
  * @param {any} a - Primeiro valor a ser comparado. 
  * @param {any} b - Segundo valor a ser comparado. 
  * @returns {boolean} Retorna `true` se os valores forem equivalentes em JSON. 
  */

  isEqualJson = (a: any, b: any) => {
    return JSON.stringify(a) === JSON.stringify(b);
  };

  /** 
  * Converte um caminho de propriedades em uma chave no formato string. 
  * Recebe um array representando o caminho de um campo dentro do JSON 
  * e transforma esse caminho em uma string separada por pontos. 
  * Exemplo: * `["empresa", "endereco", "cidade"]` vira `"empresa.endereco.cidade"`. 
  * @param {Array<string | number>} path - Caminho do campo no objeto JSON. 
  * @returns {string} Chave formatada com os níveis separados por ponto.
  */

  pathToKey = (path: Array<string | number>) => {
    return path.map(String).join(".");
  };

  /**
  * Gera um patch com as diferenças entre o objeto original e o objeto editado.
  *
  * O método percorre recursivamente os dois objetos e identifica quais campos
  * foram alterados, adicionados ou removidos. As alterações são organizadas em
  * dois grupos:
  *
  * - `$set`: campos que devem ser criados ou atualizados;
  * - `$unset`: campos que devem ser removidos.
  *
  * Campos presentes em `restrictData` são ignorados quando estão no primeiro
  * nível do objeto, impedindo alterações em dados sensíveis ou protegidos.
  *
  * Arrays são comparados como um todo. Caso exista diferença entre o array
  * original e o array editado, o array inteiro é enviado em `$set`.
  *
  * @param {any} original - Objeto original antes da edição.
  * @param {any} editado - Objeto contendo os dados editados.
  * @param {Array<string | number>} path - Caminho atual dentro do objeto durante a recursão.
  * @param {{ $set: Record<string, any>, $unset: Record<string, 1> }} patch - Objeto acumulador das alterações.
  * @returns {{ $set: Record<string, any>, $unset: Record<string, 1> }} Patch contendo os campos alterados e removidos.
  */

  getPatch = (
    original: any,
    editado: any,
    path: Array<string | number> = [],
    patch = {
      $set: {} as Record<string, any>,
      $unset: {} as Record<string, 1>
    }
  ) => {
    const originalObj = this.isObject(original);
    const editadoObj = this.isObject(editado);

    if (Array.isArray(original) || Array.isArray(editado)) {
      if (!this.isEqualJson(original, editado)) {
        const key = this.pathToKey(path);

        if (key) {
          patch.$set[key] = editado;
        }
      }

      return patch;
    }

    if (!originalObj || !editadoObj) {
      if (!this.isEqualJson(original, editado)) {
        const key = this.pathToKey(path);

        if (key) {
          patch.$set[key] = editado;
        }
      }

      return patch;
    }

    const keys = new Set([
      ...Object.keys(original || {}),
      ...Object.keys(editado || {})
    ]);

    keys.forEach((key) => {

      if (path.length === 0 && this.restrictData.includes(key)) {
        return;
      }

      const nextPath = [...path, key];

      if (!(key in editado)) {
        patch.$unset[this.pathToKey(nextPath)] = 1;
        return;
      }

      if (!(key in original)) {
        patch.$set[this.pathToKey(nextPath)] = editado[key];
        return;
      }

      this.getPatch(original[key], editado[key], nextPath, patch);
    });

    return patch;
  };

  handleErrosRelatorio(error?: any) {

    const list_erros = Array.isArray(error)
      ? error
      : String(error).split(",");

    this.obs.erros_relatorio = list_erros.map((x, index) => {
      return {
        id: index + 1,
        erros: typeof x === "string" ? x : JSON.stringify(x)
      };
    });

    this.obs.open_erros_relatorio = true;
  }

  /**
  * Reinicia as tarefas selecionadas pelo usuário.
  *
  * Valida se existe ao menos uma tarefa selecionada e filtra as tarefas que
  * podem ser reiniciadas de acordo com regras específicas por tipo e status.
  *
  * Algumas tarefas não podem ser reiniciadas quando já foram concluídas ou
  * enviadas à SERPRO. Quando isso acontece, essas tarefas são ignoradas e uma
  * mensagem de erro é exibida ao usuário.
  *
  * Após enviar as tarefas válidas para reinício, limpa a seleção, atualiza a
  * listagem e, caso a API retorne erros, abre o modal de erros das solicitações.
  *
  * @async
  * @returns {Promise<void>} Não retorna valor diretamente.
  */

  handleRestart = async () => {

    const partition =
      this.obs.partition === "" || this.obs.partition == null
        ? null
        : Number(this.obs.partition);

    if (partition !== null && (!Number.isInteger(partition) || partition < 0)) {
      toast.warning("A partição deve ser um número inteiro maior ou igual a 0.", {});
      return;
    }

    this.obs.open_partition = false

    const selectedRows = this.obs.selectedRows;

    if (selectedRows.length === 0) {
      toast.warning("Por favor, selecione pelo menos uma tarefa para reiniciar.", {});
      return;
    }

    const okTasks = selectedRows.filter(row => {
      if (row.tipo === "sitfis") {
        return row?.status !== 4 && row?.status !== 2;
      }

      if (["pgdas", "gera_das", "mudanca_regime", "caixapostal"].includes(row.tipo)) {
        return row?.status !== 2;
      }

      return true;
    });

    if (selectedRows.length !== okTasks.length) {

      toast.error(`Tarefas concluídas e enviadas à SERPRO não podem ser reiniciadas.`);

    }

    let params = {
      itens: okTasks,
      partition: partition,
      forcar_reinicializacao: this.obs.forcar_reinicializacao
    }

    this.obs.loading = true

    let resp: any = await BotsAdminStore.handleRestartBots(params)

    this.obs.selectedRows = []

    this.handleBuscaClick()

    if (resp?.length > 0) {

      this.obs.erros_solicitacoes = resp

      this.obs.open_erros_bots = true

    }

    this.obs.selectedRows = []

    this.obs.loading = false

  };

  /**
  * Altera a página atual da listagem de bots/tarefas.
  *
  * Valida se o tipo da tarefa foi selecionado antes de realizar a busca.
  * Em seguida, monta os parâmetros com os filtros atuais da tela e solicita
  * à store o carregamento dos registros da página informada.
  *
  * Esse método normalmente é utilizado pela paginação da tabela.
  *
  * @async
  * @param {number} page - Número da página que deve ser carregada.
  * @returns {Promise<void>} Não retorna valor diretamente.
  */

  handlePageChange = async (page: number) => {

    if (!this.obs.tipo.cod) {
      toast.warn("Selecione o tipo da tarefa que deseja buscar!")
      return
    }

    let params = {
      id: this.obs.id,
      task_id: this.obs.task_id,
      cnpj: this.obs.cnpj,
      tipo: this.obs.tipo.cod,
      tipo_p: this.obs.tipo.cod === "parcelamentos" ? this.obs.categoria_parcela : 0,
      status: this.obs.status,
      finalizado: this.obs.finalizado,
      erro: this.obs.erro,
      dataInicial: this.state.date1,
      dataFinal: this.state.date2,
      conta_id: this.obs.conta_id,
      estado: this.obs.lista_estados,
      modelo: this.obs.modelo_nota,
      page: page,
      limit: 15
    }

    await BotsAdminStore.handleGetBots(params)

  };

  /**
  * Controla a seleção individual de uma linha da tabela de bots/tarefas.
  *
  * Quando a linha é marcada, adiciona a tarefa à lista de selecionadas,
  * armazenando apenas os dados necessários para ações em massa.
  *
  * Quando a linha é desmarcada, localiza a tarefa correspondente na lista
  * de selecionadas e remove esse item.
  *
  * @param {any} row - Linha/tarefa selecionada ou desmarcada na tabela.
  * @param {boolean} checked - Indica se a linha foi marcada ou desmarcada.
  * @returns {void}
  */

  onSelect = (row, checked) => {

    if (checked) {

      this.obs.selectedRows.push({ id: row._id, tipo: this.obs.tipo.cod, status: row.status });

    } else {

      let index = this.obs.selectedRows.findIndex(obj => obj.id === row._id);

      if (index !== -1) {
        this.obs.selectedRows.splice(index, 1);
      }

    }

  }

  /**
  * Seleciona ou limpa todas as linhas da tabela de bots/tarefas.
  *
  * Quando o parâmetro `check` está ativo, percorre todas as linhas recebidas
  * e adiciona cada tarefa à lista de selecionadas, armazenando apenas os dados
  * necessários para ações em massa, como reiniciar tarefas.
  *
  * Quando `check` está desativado, limpa completamente a lista de tarefas
  * selecionadas.
  *
  * @async
  * @param {boolean} check - Indica se todas as linhas foram marcadas ou desmarcadas.
  * @param {any[]} row - Lista de linhas/tarefas disponíveis para seleção.
  * @returns {Promise<void>} Não retorna valor diretamente.
  */

  handleRowSelectAll = async (check, row) => {

    if (check) {

      row?.map(value => {

        this.obs.selectedRows.push({ id: value._id, tipo: this.obs.tipo.cod, status: value.status });

      });

    } else {

      this.obs.selectedRows = [];
    }

  };

  /**
  * Atualiza o período de datas selecionado pelo usuário.
  *
  * Recebe o valor selecionado no componente de período, converte esse valor
  * para string, separa as datas inicial e final e atualiza o estado com as
  * datas formatadas no padrão `YYYY-MM-DD`.
  *
  * Caso alguma das datas seja inválida, o respectivo campo é limpo.
  * Ao final, mantém o valor original selecionado em `obs.selectedPeriod`.
  *
  * @param {any} val - Valor do período selecionado, normalmente contendo data inicial e data final.
  * @returns {void}
  */

  handleDateChange = (val: any) => {
    var string = val.toString();

    var array = string.split(",");

    this.setState({ date1: moment(array[0]).format("YYYY-MM-DD") });
    this.setState({ date2: moment(array[1]).format("YYYY-MM-DD") });

    if (moment(array[0]).format("YYYY-MM-DD") == "Data inválida") {
      this.setState({ date1: "" });
    }

    if (moment(array[1]).format("YYYY-MM-DD") == "Data inválida") {
      this.setState({ date2: "" });
    }

    this.obs.selectedPeriod = val;
  };

  /**
  * Executa a busca de bots/tarefas com base nos filtros informados na tela.
  *
  * Antes de realizar a busca, valida se o tipo da tarefa foi selecionado.
  * Para tipos diferentes de `"parcelamentos"`, também exige o preenchimento
  * do período de criação.
  *
  * Após as validações, monta os parâmetros da consulta, redefine a paginação
  * para a primeira página, ativa o loading da listagem e chama a store
  * responsável por carregar os bots.
  *
  * @async
  * @returns {Promise<void>} Não retorna valor diretamente.
  */

  handleBuscaClick = async () => {

    if (!this.obs.tipo.cod) {
      toast.warn("Selecione o tipo da tarefa que deseja buscar!")
      return
    }

    if (this.obs.tipo.cod != "parcelamentos" && (!this.state.date1 || !this.state.date2)) {
      toast.warn("Preencha o campo \"Período criado\".")
      return
    }

    let params = {
      id: this.obs.id,
      task_id: this.obs.task_id,
      cnpj: this.obs.cnpj,
      tipo: this.obs.tipo.cod,
      tipo_p: this.obs.tipo.cod === "parcelamentos" ? this.obs.categoria_parcela : 0,
      status: this.obs.status,
      finalizado: this.obs.finalizado,
      erro: this.obs.erro,
      dataInicial: this.state.date1,
      dataFinal: this.state.date2,
      conta_id: this.obs.conta_id,
      estado: this.obs.lista_estados,
      modelo: this.obs.modelo_nota,
      page: 1,
      limit: 15
    }

    BotsAdminStore.obs.currentPageBot = 1

    this.obs.loading_solicitacoes = true

    await BotsAdminStore.handleGetBots(params)

    this.obs.loading_solicitacoes = false

  };

  /**
  * Abre a visualização de detalhes de uma tarefa/bot selecionado.
  *
  * Armazena os dados da linha selecionada em `obs.tarefa` e altera o estado
  * responsável por exibir o modal ou painel de detalhes.
  *
  * @param {any} row - Dados da linha/tarefa selecionada na tabela.
  * @returns {void}
  */

  handleViewDetalhes(row) {

    this.obs.tarefa = row

    this.obs.open_detalhes = true

  }

  /**
  * Realiza o download de um arquivo relacionado a uma tarefa/bot.
  *
  * Ativa o estado de carregamento do download, chama a store responsável por
  * baixar o arquivo com base no tipo selecionado e nos dados da linha informada,
  * e ao final desativa o loading.
  *
  * @async
  * @param {any} row - Dados da linha/tarefa utilizada para localizar o arquivo.
  * @returns {Promise<void>} Não retorna valor diretamente.
  */

  async handleDownloadFile(row) {

    this.obs.loading_download = true

    await BotsAdminStore.handleDownloadFile(this.obs.tipo.cod, row)

    this.obs.loading_download = false

  }

  async handleDownloadRelatorio(row) {
    this.obs.loading_download = true;

    await BotsAdminStore.handleDownloadFile("relatorio", row);

    this.obs.loading_download = false;
  }

  async handleExportTasks() {

    if (!this.obs.tipo.cod) {
      toast.warn("Selecione o tipo da tarefa que deseja buscar!");
      return;
    }

    if (this.obs.tipo.cod != "parcelamentos" && (!this.state.date1 || !this.state.date2)) {
      toast.warn("Preencha o campo \"Período criado\".");
      return;
    }

    try {

      this.obs.loading_exportar = true;

      await BotsAdminStore.handleExportPlanilha(
        this.obs.id,
        this.obs.task_id,
        this.obs.cnpj,
        this.obs.tipo.cod,
        this.obs.tipo.cod === "parcelamentos" ? this.obs.categoria_parcela : 0,
        this.obs.status,
        this.obs.finalizado,
        this.obs.erro,
        this.state.date1,
        this.state.date2,
        this.obs.conta_id
      );

      const periodoRelatorio = getPeriodoMesAtual();

      this.obs.tabAtiva = "relatorios";
      this.obs.current_page = 1;

      this.obs.selectedPeriodoRelatorio = periodoRelatorio.periodo;
      this.obs.relatorio_date1 = periodoRelatorio.date1;
      this.obs.relatorio_date2 = periodoRelatorio.date2;

      this.obs.relatorio_cnpj = this.obs.cnpj;

      await this.handleBuscarRelatorios(1);

      toast.success("Exportação solicitada com sucesso!");

    } catch (error) {

      console.error(error);

      toast.error("Não foi possível exportar as tarefas.");

    } finally {

      this.obs.loading_exportar = false;
      
    }
  }

  /**
  * Busca todas as tarefas/bots de acordo com os filtros atuais e seleciona os registros encontrados.
  *
  * Monta os parâmetros de busca com base nos filtros preenchidos na tela,
  * solicita à store a lista completa de bots correspondentes e, caso existam
  * resultados, exibe uma confirmação para o usuário antes de selecionar todos.
  *
  * A confirmação informa a quantidade de tarefas que serão selecionadas,
  * formatando o número no padrão brasileiro.
  *
  * @async
  * @returns {Promise<void>} Não retorna valor diretamente.
  */

  async handleAllRestart() {

    this.obs.loading_solicitacoes = true

    let params = {
      id: this.obs.id,
      task_id: this.obs.task_id,
      cnpj: this.obs.cnpj,
      tipo: this.obs.tipo.cod,
      tipo_p: this.obs.tipo.cod === "parcelamentos" ? this.obs.categoria_parcela : 0,
      status: this.obs.status,
      finalizado: this.obs.finalizado,
      erro: this.obs.erro,
      dataInicial: this.state.date1,
      dataFinal: this.state.date2,
      conta_id: this.obs.conta_id,
      estado: this.obs.lista_estados,
      modelo: this.obs.modelo_nota,
    }

    let resp = await BotsAdminStore.handleGetAllBots(params)

    this.obs.loading_solicitacoes = false

    if (resp.length) {

      const label = resp.length === 1 ? "tarefa" : "tarefas";

      if (!window.confirm(`Você está prestes a selecionar ${new Intl.NumberFormat("pt-BR").format(resp.length)} ${label}. Deseja continuar?`)) {
        return
      }

      this.obs.selectedRows = resp

    }

  }

  /**
  * Altera o tipo selecionado e reseta filtros específicos quando necessário.
  *
  * Atualiza o estado `obs.tipo` com o tipo recebido pelo componente.
  * Caso o tipo selecionado seja `"parcelamentos"`, limpa o período selecionado
  * e redefine os campos de data utilizados no filtro.
  *
  * @param {{ cod: string, descricao: string }} e - Tipo selecionado, contendo código e descrição.
  * @returns {void}
  */

  handleChangeTipo(e: { cod: string, descricao: string }) {

    this.obs.tipo = e

    this.obs.status = "";
    this.obs.finalizado = "todos";
    this.obs.erro = "todos";
    this.obs.lista_estados = "";
    this.obs.modelo_nota = "";

    this.obs.categoria_parcela = 0;

    if (e.cod === "parcelamentos") {

      this.obs.selectedPeriod = []
      this.setState({ date1: "", date2: "" });

    }

  }

  handlePeriodoRelatorioChange = (val: any) => {
    const array = val.toString().split(",");

    const inicio = moment(array[0]);
    const fim = moment(array[1]);

    this.obs.relatorio_date1 = inicio.isValid() ? inicio.format("YYYY-MM-DD") : "";
    this.obs.relatorio_date2 = fim.isValid() ? fim.format("YYYY-MM-DD") : "";

    this.obs.selectedPeriodoRelatorio = val;
  };

  handleBuscarRelatorios = async (page = 1) => {
    if (!this.obs.relatorio_date1 || !this.obs.relatorio_date2) {
      toast.warn("Preencha o período da solicitação.");
      return;
    }

    this.obs.loading_relatorios = true;
    this.obs.current_page = page;

    const cnpjLimpo = (this.obs.relatorio_cnpj || "").replace(/[^\d]/g, "");

    await BotsAdminStore.handleTasksPaged(page, cnpjLimpo, this.obs.relatorio_date1, this.obs.relatorio_date2);

    this.obs.loading_relatorios = false;
  };

  handleChangePageRelatorios = async (page: number) => {
    await this.handleBuscarRelatorios(page);
  };

  onCloseErrosRelatorio = () => {
    this.obs.open_erros_relatorio = false;
    this.obs.erros_relatorio = [];
  };

  /**
  * Cria uma cópia de um objeto JSON.
  *
  * Converte o valor recebido para string JSON e depois o reconverte para objeto,
  * gerando uma nova referência em memória. Isso evita que alterações feitas na
  * cópia afetem diretamente o objeto original.
  *
  * Caso o valor recebido seja nulo, indefinido ou falso, utiliza um objeto vazio
  * como valor padrão.
  *
  * @param {any} value - Valor que será clonado.
  * @returns {any} Cópia do valor informado, ou um objeto vazio.
  */

  cloneJson = (value: any) => {
    return JSON.parse(JSON.stringify(value || {}));
  };

  /**
  * Abre o modal de edição para uma tarefa selecionada.
  *
  * Armazena a tarefa original, cria uma cópia independente dos dados para edição
  * e altera o estado responsável por exibir o modal/painel de edição.
  *
  * A cópia da tarefa é importante para evitar alterações diretas no objeto
  * original antes que o usuário confirme o salvamento.
  *
  * @param {any} row - Objeto da tarefa selecionada na listagem.
  * @returns {void}
  */

  handleEdit = (row: any) => {
    this.obs.tarefa_original = row;
    this.obs.tarefa_editada = this.cloneJson(row);
    this.obs.open_editar = true;
  };

  /**
  * Fecha o modal de edição e limpa os dados temporários da tarefa editada.
  *
  * Esse método é utilizado quando o usuário cancela ou encerra a edição.
  * Ele redefine o estado relacionado à edição, removendo a tarefa original
  * e limpando o objeto usado para armazenar os dados editados.
  *
  * @returns {void}
  */

  handleCloseEdit = () => {
    this.obs.open_editar = false;
    this.obs.tarefa_original = null;
    this.obs.tarefa_editada = {};
  };

  /**
  * Salva as alterações realizadas na edição de uma tarefa/bot.
  *
  * Valida se existe uma tarefa original identificável, calcula as diferenças
  * entre o objeto original e o objeto editado, monta um patch com os campos
  * alterados e envia essas alterações para a API.
  *
  * Caso nenhuma alteração tenha sido feita, a operação é interrompida e uma
  * mensagem informativa é exibida ao usuário.
  *
  * Após salvar com sucesso, fecha o modal de edição, limpa os dados temporários
  * da edição e atualiza a listagem chamando `handleBuscaClick`.
  *
  * @async
  * @returns {Promise<void>} Não retorna valor diretamente.
  */

  handleSaveEdit = async () => {
    if (!this.obs.tarefa_original?._id) {
      toast.error("Não foi possível identificar a tarefa para salvar.");
      return;
    }

    try {

      this.obs.loading_editar = true;

      const patch = this.getPatch(
        this.obs.tarefa_original,
        this.obs.tarefa_editada
      );

      const hasSet = Object.keys(patch.$set).length > 0;
      const hasUnset = Object.keys(patch.$unset).length > 0;

      if (!hasSet && !hasUnset) {
        toast.info("Nenhuma alteração foi feita.");
        return;
      }

      const params = {
        id: this.obs.tarefa_original._id,
        tipo: this.obs.tipo.cod,
        campos_alterados: patch
      };

      await BotsAdminStore.handleUpdateBot(params);

      this.obs.open_editar = false;
      this.obs.tarefa_original = null;
      this.obs.tarefa_editada = {};

      await this.handleBuscaClick();

    } catch (error) {

      console.error(error);

      toast.error("Não foi possível salvar a edição do JSON.");

    } finally {

      this.obs.loading_editar = false;

    }
  };

  handleValuePartition = (valueAsNumber: number, valueAsString: string) => {

    this.obs.partition = valueAsString.replace(/\D/g, "")

  };

  handleForcarReenvio() {

  }

  render() {

    function statusFormatter(cell, row) {
    
      return getTag(row.status, "relatorio");

    }

    const itemsRelatorios = BotsAdminStore.obs.tasks_relatorio || [];

    const cnpjFormatter = (cell) => {
      return cell ? formatCnpj(cell) : "N/A";
    };

    const dateFormatter = (cell) => {
      if (!cell) return "N/A";
      return moment.utc(new Date(cell)).format("DD/MM/YYYY HH:mm");
    };

    const fileFormatter = (cell, row) => {
      if (!row.relatorio_id && !row.id && !row._id) return <></>;

      return (
        <IconButton onClick={() => this.handleDownloadRelatorio(row)}>
          <img src="/images/download.svg" width="18px" />
        </IconButton>
      );
    };

    const errosFormatter = (cell, row) => {
      const erro = row.error || row.errors || row.erro || row.erros;

      return (
        <MDBBtn
          color="default"
          rounded
          size="sm"
          disabled={row.status != 3 || !erro}
          onClick={() => this.handleErrosRelatorio(erro)}
        >
          <img src="/images/view.png" width="18px" />
        </MDBBtn>
      );
    };

    const formatDetalhes = (row) => {

      return (<IconButton onClick={(e) => this.handleViewDetalhes(row)}>
        <img src="/images/view.png" width="18px" />
      </IconButton>);

    }

    const formatDownload = (row) => {

      if(![2, 19, 20, 21, 22, 23].includes(row.status)) return (<></>)

      const tiposIgnorados = [
        "caixapostal", "calculo", "contestacao", "manifestacao", "solicitacao_sefa", "xml_integration",
        "dec_ler", "dec_download", "nfe_fazenda", "manifestacao_chaves", "parcelamentos",
        "email", "telegram", "whatsapp", "det"
      ];

      if (tiposIgnorados.includes(this.obs.tipo.cod)) return (<></>)

      return (

        <IconButton onClick={(e) => this.handleDownloadFile(row)} disabled={![2, 19, 20, 21, 22, 23].includes(row.status)}>
          <img src="/images/download.svg" width="18px" />
        </IconButton>

      );
    }

    const columns = [
      {
        dataField: '_id',
        text: 'ID',
        isKey: true,
      },
      {
        dataField: 'tipo',
        text: 'Tipo',
        editable: false,
        formatter: (cell) => (this.obs.tipo.cod || "").toUpperCase(),
        headerStyle: { textAlign: 'center' },
        style: { textAlign: 'center' },
      },
      {
        dataField: 'cnpj',
        text: 'CNPJ',
        editable: false,
        formatter: (cell, row) => {

          if (cell) {

            return formatCnpj(cell)

          } else {

            if (row.cnpj_destino) {

              return formatCnpj(row.cnpj_destino)

            }

            return "N/A"

          }

        },
        headerStyle: { textAlign: 'center' },
        style: { textAlign: 'center' },
      },
      {
        dataField: 'status',
        text: "Status",
        editable: false,
        formatter: (cell, row) => formatStatusTask(cell, row),
        headerStyle: { width: '300px', textAlign: 'center' },
        style: { textAlign: 'center' },
      },
      {
        dataField: 'status',
        text: "Finalizado",
        editable: false,
        formatter: (cell) => formatFinalizado(cell),
        headerStyle: { textAlign: 'center' },
        style: { textAlign: 'center' },
      },
      {
        dataField: 'status',
        text: "Erro",
        editable: false,
        formatter: (cell) => formatErro(cell),
        headerStyle: { textAlign: 'center' },
        style: { textAlign: 'center' },
      },
      {
        dataField: 'inserted_at',
        text: 'Criado em',
        editable: false,
        formatter: (cell, row) => formatDate(cell, row._insertedTS),
        headerStyle: { textAlign: 'center' },
        style: { textAlign: 'center' },
      },
      {
        dataField: '_modifiedTS',
        text: 'Última atualização',
        editable: false,
        formatter: (cell, row) => {
          if (!cell || cell.trim() === "") {
            return "Sem atualização";
          }
          return formatDate(cell, row.updated_at);
        },
        headerStyle: { textAlign: 'center' },
        style: { textAlign: 'center' },
      },
      {
        dataField: 'detalhes',
        text: "Detalhes",
        editable: false,
        formatter: (cell, row) => formatDetalhes(row),
        headerStyle: { textAlign: 'center' },
        style: { textAlign: 'center' },
      },
      {
        dataField: 'editar',
        text: "Editar",
        editable: false,
        formatter: (cell, row) => (
          <MDBBtn
            color="default"
            rounded
            size="sm"
            onClick={(e) => {
              e.stopPropagation();
              this.handleEdit(row);
            }}
          >
            <img src="/images/edit.png" width="25px" alt="Editar" />
          </MDBBtn>
        ),
        headerStyle: { textAlign: 'center' },
        style: { textAlign: 'center' },
      },
      {
        dataField: 'download',
        text: "Arquivo",
        editable: false,
        formatter: (cell, row) => formatDownload(row),
        headerStyle: { textAlign: 'center' },
        style: { textAlign: 'center' },
      }

    ];

    const formatStatusTask = (status, row) => {

      return getTag(status, this.obs.tipo.cod, row);

    }

    const formatDate = (dateString, optionalDate) => {

      const date = new Date((dateString || optionalDate));

      return moment.utc(date).format("DD/MM/YYYY HH:mm");
    };

    const formatFinalizado = (status) => {

      const { tipo } = this.obs;

      if (format_finalizado(status, tipo.cod)) {

        return (<span style={{ fontSize: 12 }}>SIM</span>)

      }

      return (<span style={{ fontSize: 12 }}>NÃO</span>)

    };

    const formatErro = (status) => {

      const { tipo } = this.obs;

      if (format_erro(status, tipo.cod)) {

        return (<span className="bot-tag-erro-sim">SIM</span>)

      }

      return (<span className="bot-tag-erro-nao">NÃO</span>)

    };

    const isParcelamentos = this.obs.tipo.cod === "parcelamentos";

    const selectRowProp = {
      mode: 'checkbox',
      clickToSelect: false,
      style: { backgroundColor: '#e9f6ff' },
      onSelect: this.onSelect,
      onSelectAll: this.handleRowSelectAll,
      selected: this.obs.selectedRows?.map(value => value.id),
      nonSelectable: BotsAdminStore.obs.tabelaBots.map(value => {
        if (value.gratuito && value.status == 2 && value.tipo == "receita") return value._id
        if (value.status == 2 && value.tipo == "dec_download") return value._id
      })
    };

    let erros = this.obs.erros_solicitacoes?.map(map_bot => {
      return (
        {
          id: map_bot.id,
          erro: map_bot.error,
        }
      )
    });

    let anexoText = this.obs.tipo.cod ? `${this.obs.tipo.descricao.substring(0, 30)}` : "SELECIONE";

    return (
      <>

        <Tabs
          className="tabsCalculos"
          selectedTabId={this.obs.tabAtiva}
          onChange={(tabId) => this.obs.tabAtiva = tabId as string}
          renderActiveTabPanelOnly={true}
        >
          <Tab
            id="tarefas"
            title="Tarefas"
            panel={
              <>
                <div className="filtros-principais">
                  <FormGroup className="filtro-item empresaSelect selectValues" label="Tipo">
                    <DefaultSelect
                      items={optionsTipo()}
                      itemRenderer={renderItens}
                      itemPredicate={filterItens}
                      onItemSelect={(e) => this.handleChangeTipo(e)}
                      matchTargetWidth={true}
                      inputProps={{ placeholder: 'Filtrar um Tipo' }}
                    >
                      <Button
                        className="tipo-select-bots"
                        text={anexoText}
                        rightIcon="double-caret-vertical"
                        alignText={Alignment.LEFT}
                        fill
                      />
                    </DefaultSelect>
                  </FormGroup>

                  {this.obs.tipo.cod === "parcelamentos" && (
                    <FormGroup className="filtro-item" label="Categoria Parcela">
                      <HTMLSelect
                        onChange={(e) => (this.obs.categoria_parcela = Number(e.target.value))}
                        value={this.obs.categoria_parcela}
                        fill
                      >
                        {Object.entries(categoriasParcelas).map(([value, label]) => (
                          <option key={value} value={Number(value)}>{value} - {label}</option>
                        ))}
                      </HTMLSelect>
                    </FormGroup>
                  )}

                  {this.obs.tipo.cod === "manifestacoes_download" && (
                    <>
                      <FormGroup className="filtro-item filtro-item--sm" label="Estado">
                        <HTMLSelect
                          onChange={(e) => (this.obs.lista_estados = e.target.value)}
                          value={this.obs.lista_estados}
                          fill
                        >
                          {Object.entries(listaEstados).map(([value, label]) => (
                            <option key={value} value={value}>
                              {label}
                            </option>
                          ))}
                        </HTMLSelect>
                      </FormGroup>

                      <FormGroup className="filtro-item filtro-item--sm" label="Modelo Nota">
                        <HTMLSelect
                          onChange={(e) => (this.obs.modelo_nota = e.target.value)}
                          value={this.obs.modelo_nota}
                          fill
                        >
                          {Object.entries(modeloNota).map(([value, label]) => (
                            <option key={value} value={value}>
                              {label}
                            </option>
                          ))}
                        </HTMLSelect>
                      </FormGroup>
                    </>
                  )}

                  <FormGroup className="filtro-item" label="Status">
                    <HTMLSelect
                      onChange={(e) => (this.obs.status = e.target.value)}
                      value={this.obs.status}
                      fill
                    >
                      {getOptions(this.obs.tipo.cod).map(({ value, label }) => (
                        <option key={value} value={value}>{value} - {label}</option>
                      ))}
                    </HTMLSelect>
                  </FormGroup>

                  {!isParcelamentos && (
                    <FormGroup className="filtro-item filtro-item--periodo inputsPeriodoBots" label="Período criado">
                      <DateRangePicker30
                        onChange={this.handleDateChange}
                        value={this.obs.selectedPeriod}
                        disabled={this.obs.tipo.cod === "parcelamentos"}
                      />
                    </FormGroup>
                  )}

                  <div className="filtros-acoes">
                    <IconButton
                      onClick={() => (this.obs.open_filters = !this.obs.open_filters)}
                      title="Mais filtros"
                    >
                      <AppIcon name="filter_list" />
                    </IconButton>

                    <MDBBtn className="btnDefault btnBuscarBots" onClick={() => this.handleBuscaClick()}>
                      Buscar
                    </MDBBtn>
                  </div>
                </div>

                <Collapse isOpen={this.obs.open_filters}>
                  <div
                    style={{
                      display: 'flex',
                      flexWrap: 'wrap',
                      gap: 15,
                      marginTop: 15,
                      padding: '12px 0',
                      borderTop: '1px solid #e1e8ed',
                    }}
                  >
                    <FormGroup style={{ flex: '1 1 220px', minWidth: 200 }} label="Buscar ID">
                      <InputGroup
                        placeholder="Digite o ID"
                        value={this.obs.id}
                        onChange={(e) => (this.obs.id = e.target.value)}
                        fill
                      />
                    </FormGroup>

                    <FormGroup style={{ flex: '1 1 220px', minWidth: 200 }} label="Buscar Task ID">
                      <InputGroup
                        placeholder="Digite o Task ID"
                        value={this.obs.task_id}
                        onChange={(e) => (this.obs.task_id = e.target.value)}
                        fill
                      />
                    </FormGroup>

                    <FormGroup style={{ flex: '1 1 220px', minWidth: 200 }} label="Buscar Conta ID">
                      <InputGroup
                        placeholder="Digite o Conta ID"
                        value={this.obs.conta_id}
                        onChange={(e) => (this.obs.conta_id = e.target.value)}
                        fill
                      />
                    </FormGroup>

                    <FormGroup style={{ flex: '1 1 220px', minWidth: 180 }} label="Buscar CNPJ">
                      <InputGroup
                        placeholder="Digite o CNPJ"
                        value={this.obs.cnpj}
                        onChange={(e) => (this.obs.cnpj = e.target.value)}
                        fill
                      />
                    </FormGroup>

                    <FormGroup style={{ flex: isParcelamentos ? '0 1 140px' : '0 1 180px', minWidth: 130 }} label="Finalizado">
                      <HTMLSelect
                        onChange={(e) => (this.obs.finalizado = e.target.value)}
                        value={this.obs.finalizado}
                        style={{ width: '100%' }}
                      >
                        <option value="todos">TODOS</option>
                        <option value="sim">SIM</option>
                        <option value="nao">NÃO</option>
                      </HTMLSelect>
                    </FormGroup>

                    <FormGroup style={{ flex: isParcelamentos ? '0 1 140px' : '0 1 180px', minWidth: 130 }} label="Erro">
                      <HTMLSelect
                        onChange={(e) => (this.obs.erro = e.target.value)}
                        value={this.obs.erro}
                        style={{ width: '100%' }}
                      >
                        <option value="todos">TODOS</option>
                        <option value="sim">SIM</option>
                        <option value="nao">NÃO</option>
                      </HTMLSelect>
                    </FormGroup>
                  </div>
                </Collapse>

                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    flexWrap: 'wrap',
                    gap: 10,
                    marginTop: 15,
                  }}
                >
                  <MDBBtn
                    disabled={this.obs.loading || !this.obs.selectedRows.length}
                    className="btnDefault btnBuscarNfe"
                    onClick={() => {
                      this.obs.partition = "";
                      this.obs.forcar_reinicializacao = false
                      this.obs.open_partition = true;
                    }}
                    style={{ margin: 0 }}
                  >
                    Reiniciar{" "}
                    <span style={{ fontSize: 12 }}>
                      {new Intl.NumberFormat("pt-BR").format(this.obs.selectedRows.length)}
                    </span>{" "}
                    {this.obs.selectedRows.length === 1 ? "tarefa selecionada" : "tarefas selecionadas"}
                  </MDBBtn>

                  <div style={{ display: 'flex', gap: 10 }}>
                    <MDBBtn
                      disabled={this.obs.loading}
                      className="btnDefault btnBuscarNfe"
                      onClick={() => this.handleAllRestart()}
                      style={{ margin: 0 }}
                    >
                      Selecionar todas
                    </MDBBtn>

                    <MDBBtn
                      disabled={this.obs.loading || this.obs.loading_exportar}
                      className="btnDefault btnBuscarNfe"
                      onClick={() => this.handleExportTasks()}
                      style={{ margin: 0 }}
                    >
                      Exportar Excel
                    </MDBBtn>
                  </div>
                </div>

                {/* @ts-ignore */}
                <BootstrapTable
                  keyField="_id"
                  data={BotsAdminStore.obs.tabelaBots}
                  columns={columns}
                  wrapperClasses="TableDefault tabela-excesso"
                  selectRow={selectRowProp}
                  style={{ marginTop: 15 }}
                />

                <div style={{ marginTop: 5, float: "right", marginBottom: 120 }}>
                  <Pager
                    currentPage={BotsAdminStore.obs.currentPageBot}
                    totalCount={BotsAdminStore.obs.length_bots}
                    pageSize={15}
                    onPageChange={(page) => this.handlePageChange((BotsAdminStore.obs.currentPageBot = page))}
                  />
                </div>
                <div style={{ marginBottom: 120 }} />
              </>
            }
          />

          <Tab
            id="relatorios"
            title="Relatórios"
            panel={
              <>
              <div className="alert alert-warning" style={{ display: "inherit" }}>
                <AppIcon size={20} name="warning" style={{ marginRight: 10 }} />
                As colunas do excel que são listas de dados no MongoDB estão limitados à 50 itens. <br />
              </div>
                <MDBRow>
                  <MDBCol sm="12" md="6" lg="3" xl="3">
                    <FormGroup label="CNPJ">
                      <InputGroup
                        placeholder="Digite o CNPJ"
                        value={this.obs.relatorio_cnpj}
                        onChange={(e) => (this.obs.relatorio_cnpj = e.target.value)}
                        fill
                      />
                    </FormGroup>
                  </MDBCol>

                  <MDBCol sm="12" md="6" lg="2" xl="2">
                    <FormGroup label="Período" className="inputsPeriodoCalculos">
                      <DateRangePicker30
                        onChange={this.handlePeriodoRelatorioChange}
                        value={this.obs.selectedPeriodoRelatorio} 
                        disabled={false}                      
                      />
                    </FormGroup>
                  </MDBCol>

                  <MDBCol xs="12" sm="12" md="4" lg="1" xl="1" className="colBtnBuscar">
                    <MDBBtn
                      className="btnDefault btnBuscarNfe filtroFullWidth"
                      onClick={() => this.handleBuscarRelatorios(1)}
                      disabled={this.obs.loading_relatorios}
                    >
                      Buscar
                    </MDBBtn>
                  </MDBCol>
                </MDBRow>

                <div data-tut="table">
                  <BootstrapTableOld className="TableDefault" data={itemsRelatorios} hover>
                    <TableHeaderColumn dataField="id" isKey={true} hidden width="1%">#</TableHeaderColumn>
                    <TableHeaderColumn dataFormat={cnpjFormatter} dataField="cnpj" width="20%">CNPJ</TableHeaderColumn>
                    <TableHeaderColumn dataFormat={dateFormatter} dataField="inserted_at" width="20%">Data da Solicitação</TableHeaderColumn>
                    <TableHeaderColumn dataField="status" dataFormat={statusFormatter} width="30%">Status</TableHeaderColumn>
                    <TableHeaderColumn dataFormat={fileFormatter} width="10%">Arquivo</TableHeaderColumn>
                    <TableHeaderColumn dataFormat={errosFormatter} width="10%">Erros</TableHeaderColumn>
                  </BootstrapTableOld>
                </div>

                <div style={{ marginTop: 5, float: "right", marginBottom: 120 }}>
                  <Pager
                    currentPage={this.obs.current_page}
                    totalCount={BotsAdminStore.obs.length_tasks_relatorio}
                    pageSize={15}
                    onPageChange={(page) => this.handleChangePageRelatorios(page)}
                  />
                </div>

                <Alert
                  confirmButtonText="Fechar"
                  isOpen={this.obs.open_erros_relatorio}
                  onClose={() => this.onCloseErrosRelatorio()}
                  onConfirm={() => this.onCloseErrosRelatorio()}
                  canOutsideClickCancel={true}
                  className="AlertErrorSped"
                >
                  <h2 className="titleSEFAZ">Erros</h2>
                  <MDBCol md="12">
                    {this.obs.erros_relatorio.length &&
                      <div className="errosSped">
                        <BootstrapTableOld className="nomeArquivos" data={this.obs.erros_relatorio} hover>
                          <TableHeaderColumn dataField='id' isKey={true} hidden width='1%'>#</TableHeaderColumn>
                          <TableHeaderColumn dataField='erros' width='100%'></TableHeaderColumn>
                        </BootstrapTableOld>
                      </div>
                    }
                  </MDBCol>
                </Alert>

                <LoadingModal open={this.obs.loading} onClose={() => this.obs.loading = false} title={"Baixando arquivo"} />
              </>
            }

          />

          <Tab
            id="sefa_erros"
            title="Sefa Erros"
            panel={<SefaErrosPage/>}
          />

        </Tabs>
        <Alert
          confirmButtonText="Fechar"
          isOpen={this.obs.open_erros_bots}
          onConfirm={() => this.obs.open_erros_bots = false}
          className="AlertUser"
          intent="primary"
        >
          <h2 className="titleSEFAZ">Erros ocorridos durante a Reinicialização</h2>
          <p style={{ marginBottom: 25, marginTop: -25 }}>
            Para as empresas listadas abaixo, será necessário realizar a reinicialização.
          </p>
          <MDBCol md="12">
            {erros.length &&
              <div className="erroBots">
                <BootstrapTableOld data={erros} hover>
                  <TableHeaderColumn dataField='id' isKey={true} hidden width='1%'>#</TableHeaderColumn>
                  <TableHeaderColumn dataField='id' width='20%'>ID</TableHeaderColumn>
                  <TableHeaderColumn dataField='erro' width='50%'>Erro</TableHeaderColumn>
                </BootstrapTableOld>
              </div>
            }
          </MDBCol>
        </Alert>

        <Alert
          confirmButtonText="Fechar"
          isOpen={this.obs.open_detalhes}
          onClose={() => this.obs.open_detalhes = false}
          canOutsideClickCancel={true}
          intent="primary"
        >
          <h2 className="titleSEFAZ">Detalhes</h2>

          <div className="heightResposta">
            <ReactJson collapsed={false} displayDataTypes={false} src={this.obs.tarefa} />
          </div>

        </Alert>

        <Alert
          confirmButtonText={this.obs.loading_editar ? "Salvando..." : "Salvar"}
          cancelButtonText="Cancelar"
          isOpen={this.obs.open_editar}
          onConfirm={() => this.handleSaveEdit()}
          onCancel={() => this.handleCloseEdit()}
          onClose={() => this.handleCloseEdit()}
          canOutsideClickCancel={false}
          canEscapeKeyCancel={true}
          intent="primary"
          className="AlertUser alert-json-edit"
        >
          <h2 className="titleSEFAZ">Editar JSON da tarefa</h2>

          <div
            style={{
              maxHeight: "70vh",
              overflow: "auto",
              textAlign: "left",
              paddingRight: 10
            }}
          >
            <JsonEditor
              data={this.obs.tarefa_editada}
              setData={(data: any) => {
                this.obs.tarefa_editada = data;
              }}
              rootName="tarefa"
              collapse={2}
              indent={3}
              enableClipboard={true}
              restrictDrag={true}
              restrictEdit={(node: any) => this.isCampoSensivel(node.path)}
              restrictAdd={true}
              restrictDelete={true}
              restrictTypeSelection={true}
              theme={{ styles: {
                "container": {
                  backgroundColor: "#fff",
                  fontSize: 12
                }
              } }}
            />
          </div>
        </Alert>

        <Dialog isOpen={this.obs.open_partition} onClose={() => this.obs.open_partition = false}>
          <h2 className="titleSEFAZ" style={{ marginBottom: 5 }}>Reiniciar</h2>

          <br/>

          <FormGroup style={{width: 800}} label="Partição" labelInfo="(Opcional)" helperText={
            <>
              Deixe este campo em branco para que o sistema escolha a partição automaticamente. Caso informe um valor, utilize um número inteiro positivo (incluindo 0). Se a partição informada não existir, a operação retornará um erro.
            </>
          }>
            <NumericInput
              className="input-numeric"
              value={this.obs.partition}
              onValueChange={this.handleValuePartition}
              buttonPosition="none"
              placeholder="Exemplo: 1"
              style={{width: 200}}
              min={0}
              minorStepSize={null}
              allowNumericCharactersOnly
            />
          </FormGroup>

          {["download_sefa", "solicitacao_sefa", "nfe_fazenda", "manifestacao_chaves"].includes(this.obs.tipo.cod) && (
            <FormGroup
              label="Forçar reinicialização"
              style={{ marginRight: 30 }}
            >
              <Switch
                label={this.obs.forcar_reinicializacao ? "Sim" : "Não"}
                checked={this.obs.forcar_reinicializacao}
                onChange={(e: any) => this.obs.forcar_reinicializacao = e.target.checked}
              />
            </FormGroup>
          )}

          <div className={Classes.DIALOG_FOOTER_ACTIONS}>
            <Button text="Cancelar" onClick={() => this.obs.open_partition = false} />
            <Button text="Confirmar" intent="primary" onClick={() => this.handleRestart()} />
          </div>

        </Dialog>

        <LoadingModal open={this.obs.loading_download} onClose={() => this.obs.loading_download = false} title={"Baixando arquivo"} />
        <LoadingModal open={this.obs.loading_solicitacoes} onClose={() => this.obs.loading_solicitacoes = false} title={"Carregando"} />
        <LoadingModal open={this.obs.loading_exportar} onClose={() => this.obs.loading_exportar = false} title={"Exportando tarefas"} />
      </>
    );
  }
}
